"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGroupNotificationSettings = void 0;
var usePaginatedModel_1 = __importDefault(require("./usePaginatedModel"));
var useGroupNotificationSettings = function (groupId) {
    var _a, _b;
    var res = (0, usePaginatedModel_1.default)('users/group-notification-settings', {
        limit: 1,
        page: 1,
        group_id: groupId,
    });
    return {
        invalidateData: res.invalidateData,
        notifications: (_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.results) === null || _b === void 0 ? void 0 : _b[0],
    };
};
exports.useGroupNotificationSettings = useGroupNotificationSettings;
exports.default = exports.useGroupNotificationSettings;
//# sourceMappingURL=useGroupsNotificationSettings.js.map